import { jwtDecode } from "jwt-decode";

//Funmctions for setting and clearing cookies.

export function setCookieFunction(name:string, value:string, days:number) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/; Secure;";
};

// Function to get a cookie by name
export function getCookie(name:string){
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        const part = parts.pop();
        if (part) return part.split(";").shift();
    }
    return null;
};

export async function getUserClaims(){
    if (getCookie("access_token")){
        const token = getCookie("access_token");
        if (!token) {
            return false;
          }
          try {
            //const aToken = JSON.parse(token).access_token;        
            const decodedToken = jwtDecode(token);
            return decodedToken;
        } catch (error) {
            console.log("Error" + error);
            return false;
          }    
      }else{
          console.log("Cookie Not Set");
          return false;
      }
}